module.exports = __webpack_public_path__ + "static/img/polo-poschiavo.c39cc25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/polo-poschiavo.jpg
// module id = D3Vz
// module chunks = 1